"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIndexTopicIdsMap = void 0;
exports.shouldHideCategoryMetadata = shouldHideCategoryMetadata;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var communityId = (0, _globals.default)('communityId');

var getIndexTopicIdsMap = function getIndexTopicIdsMap(allSearchResults) {
  if (!allSearchResults) {
    return null;
  }

  var indexTopicIdsSet = {}; // Check if the search results are from multiple indices

  if (allSearchResults[communityId]) {
    Object.entries(allSearchResults).forEach(function (_ref) {
      var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
          key = _ref2[0],
          result = _ref2[1];

      if (!indexTopicIdsSet[key]) {
        indexTopicIdsSet[key] = new Set();
      }

      if (key === communityId) {
        result.hits.forEach(function (_ref3) {
          var id = _ref3.id;
          return indexTopicIdsSet[key].add(id);
        });
      } else if (key) {
        result.hits.forEach(function (_ref4) {
          var objectID = _ref4.objectID;
          return indexTopicIdsSet[key].add(objectID);
        });
      }
    });
  } else {
    indexTopicIdsSet[communityId] = new Set();
    allSearchResults.hits.forEach(function (_ref5) {
      var id = _ref5.id;
      return indexTopicIdsSet[communityId].add(id);
    });
  }

  var indexTopicIdsMap = {};
  Object.keys(indexTopicIdsSet).forEach(function (key) {
    var value = Array.from(indexTopicIdsSet[key]);

    if (value.length) {
      indexTopicIdsMap[key] = value;
    }
  });
  return indexTopicIdsMap;
};

exports.getIndexTopicIdsMap = getIndexTopicIdsMap;

function shouldHideCategoryMetadata(topicInfo) {
  return topicInfo.contentType === 'idea' || topicInfo.contentType === 'productUpdate';
}